export default (begin, end, inc = 1) => {
  var arr = [];
  for (var i = begin; i < end; i += inc) {
    arr.push(i);
  }
  return arr;
};



// WEBPACK FOOTER //
// ./src/utils/range.js